import { render, staticRenderFns } from "./PagosProveedor.vue?vue&type=template&id=3a91672e&"
import script from "./PagosProveedor.vue?vue&type=script&lang=js&"
export * from "./PagosProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports